module.exports = __webpack_public_path__ + "static/media/seguradora_sulamerica.9edc41de.png";